import Student from "types/Student";
import { GroupSummaryCard } from "./GroupSummaryCard";
import { StudentSummary } from "./StudentSummary";
import StudentFilter from "types/StudentFilter";
import { Chat } from "./Chat";

interface LearningPanelProps {
  student: Student | null;
  filter: StudentFilter;
  students: Student[];
}

export function LearningPanel({
  student,
  filter,
  students,
}: LearningPanelProps) {
  return (
    <div className="flex flex-col h-full space-y-2 lg:space-y-4 overflow-hidden">
      {student ? (
        <>
          <StudentSummary student={student} />
          <div className="flex-1 overflow-hidden w-full">
            <Chat
              key={student.id}
              teacherId={1}
              student={student}
              phone={student.phone}
            />
          </div>
        </>
      ) : filter.gradeLevel || filter.subject ? (
        <>
          <GroupSummaryCard filter={filter} studentCount={students.length} />

          {/* Commented for now */}
          {/* <div className="flex-1 overflow-hidden">
            <BroadcastChat />
          </div> */}
        </>
      ) : (
        <div className="text-gray-400 text-xs lg:text-sm text-center py-8">
          Select a subject or student to see details.
        </div>
      )}
    </div>
  );
}
